// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * A chip's preview (ChipPreview.tsx), in the light look the owner picked for
 * the one Curio tooltip: dark text on its white card, secondary text grey, a
 * table's column names over their dtypes, and a rule under them. The card
 * itself (its border, shadow and padding) is the tooltip's.
 */

/* Its height is capped inline (ChipPreview.tsx), the card's less its padding:
   the head and the foot keep theirs, and the body between them is cut. */
.KjMiwpmsI8MADDc29O7m {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-height: 0;
  font-family: var(--curio-font-family);
  font-size: var(--curio-font-size-sm);
  line-height: 16px;
  color: var(--curio-text-primary);
}

.dH43014DOyU4YMwvW07f {
  display: flex;
  flex: none;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 6px;
}

.ItCGGRNbHgej8j0jeXDv {
  display: flex;
  flex: 0 1 auto;
  flex-direction: column;
  gap: 6px;
  min-height: 0;
  overflow: hidden;
}

.Mj0LZWmc8mDSa7WiCrFo {
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  height: 20px;
  padding: 0 6px;
  border: 1px solid;
  border-radius: var(--curio-radius-sm);
  font-family: var(--curio-font-mono);
  font-size: var(--curio-font-size-xs);
  font-weight: 500;
  white-space: nowrap;
}

/* The chips' own colors, as the header's tags draw them (WidgetTags.module.css). */
.rVxn29MaO_K2CTe7D3DA {
  border-color: #a8d5b1;
  background: var(--curio-accent-mint-bg);
  color: var(--curio-accent-mint-fg);
}

.YSnoColimRZpc1DAK2QT {
  border-color: #a8d5b1;
  background: var(--curio-card-bg);
  color: var(--curio-accent-mint-fg);
}

.fy8hnHAYgtzCEKXcIt8i {
  border-color: #b6cbf2;
  background: var(--curio-accent-sky-bg);
  color: var(--curio-accent-sky-fg);
}

.wbBLCQwjB4WSKgQEWAaM {
  border-color: #f2b9a3;
  background: var(--curio-accent-peach-bg);
  color: #b8461d;
}

.jEP7PeWqSMxBu5ZHQwIg {
  border-color: #cdbff0;
  background: var(--curio-accent-lilac-bg);
  color: var(--curio-accent-lilac-fg);
}

.bMVTkLrkcZhU0La_Ibzu {
  border-color: var(--curio-danger-border);
  background: var(--curio-danger-bg);
  color: var(--curio-danger-text);
}

.nq4lUyy2g30urSRRQJPD {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}

.ltLawTr2bPvioObGkLNS {
  overflow-wrap: anywhere;
}

.iGaUOLg0PNQ9PpiFazyi {
  color: var(--curio-text-secondary);
}

.Z8cvXDOUPNoHYlE5AzO5 {
  font-family: var(--curio-font-mono);
  font-size: var(--curio-font-size-xs);
}

.dz9jMPDBxs59gQRvsDgp {
  color: var(--curio-danger-text);
}

.zIzqSfKieMdMVs0GJkdz {
  display: inline-block;
  flex: none;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  border-radius: 2px;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.25);
  vertical-align: -1px;
}

.hHV1x08vDjZQKcJiUgxb {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.MJXlIUc9v8FJUhJUk06M {
  border-collapse: collapse;
}

.SeEGVv_cYNO6hg7GsSQK {
  caption-side: top;
  padding-bottom: 3px;
  text-align: left;
  font-size: var(--curio-font-size-xs);
  font-weight: 600;
  color: var(--curio-text-primary);
}

.MJXlIUc9v8FJUhJUk06M th,
.MJXlIUc9v8FJUhJUk06M td {
  padding: 2px 14px 2px 0;
  white-space: nowrap;
}

.MJXlIUc9v8FJUhJUk06M th:last-child,
.MJXlIUc9v8FJUhJUk06M td:last-child {
  padding-right: 0;
}

.MJXlIUc9v8FJUhJUk06M th {
  border-bottom: 1px solid var(--curio-border);
  text-align: left;
  vertical-align: bottom;
}

.MJXlIUc9v8FJUhJUk06M td {
  font-family: var(--curio-font-mono);
  font-size: var(--curio-font-size-xs);
  line-height: 15px;
}

.MJXlIUc9v8FJUhJUk06M .EHRT7X09uzRu1lX4b5HZ {
  text-align: right;
}

/* A cell, its column's name and its dtype each end in an ellipsis at the
   width its column may take (inline, \`cellWidth\`), so every column shown
   fits the card. */
.TuGsG30TDwr9ZqdgrKPQ {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
}

.HlJCMj31ujvAlv3T9JBh {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: var(--curio-font-size-xs);
  font-weight: 600;
  line-height: 15px;
  color: var(--curio-text-primary);
}

.SWbZGXluk4o9DzUrS73h {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: var(--curio-font-mono);
  font-size: 10px;
  font-weight: 400;
  line-height: 13px;
  color: var(--curio-text-secondary);
}

.BOO3oKJ4BV2KdAMyod1p {
  color: var(--curio-text-secondary);
}

.RFaqN1_aCLdr1NInAcvB {
  flex: none;
  font-size: var(--curio-font-size-xs);
  line-height: 15px;
  color: var(--curio-text-secondary);
}

/* An editor chip's tooltip: the markers' messages there, then its preview. */
.HRuoHDBzIiEtJvJKdXTj {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.W2GpNZSTePUTPoMM6892 {
  font-family: var(--curio-font-family);
  font-size: var(--curio-font-size-sm);
  line-height: 16px;
  color: var(--curio-text-primary);
  white-space: pre-wrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/editing/widgets/ChipPreview.module.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;yEACyE;AACzE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,qCAAqC;EACrC,oCAAoC;EACpC,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,qCAAqC;EACrC,mCAAmC;EACnC,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,mFAAmF;AACnF;EACE,qBAAqB;EACrB,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;EACE,wCAAwC;EACxC,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,+CAA+C;EAC/C,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,oCAAoC;EACpC,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;EAEE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;mBAEmB;AACnB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,oCAAoC;EACpC,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,iBAAiB;EACjB,gCAAgC;EAChC,qBAAqB;AACvB","sourcesContent":["/*\n * A chip's preview (ChipPreview.tsx), in the light look the owner picked for\n * the one Curio tooltip: dark text on its white card, secondary text grey, a\n * table's column names over their dtypes, and a rule under them. The card\n * itself (its border, shadow and padding) is the tooltip's.\n */\n\n/* Its height is capped inline (ChipPreview.tsx), the card's less its padding:\n   the head and the foot keep theirs, and the body between them is cut. */\n.preview {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-height: 0;\n  font-family: var(--curio-font-family);\n  font-size: var(--curio-font-size-sm);\n  line-height: 16px;\n  color: var(--curio-text-primary);\n}\n\n.head {\n  display: flex;\n  flex: none;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px 6px;\n}\n\n.body {\n  display: flex;\n  flex: 0 1 auto;\n  flex-direction: column;\n  gap: 6px;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.chip {\n  display: inline-flex;\n  align-items: center;\n  box-sizing: border-box;\n  height: 20px;\n  padding: 0 6px;\n  border: 1px solid;\n  border-radius: var(--curio-radius-sm);\n  font-family: var(--curio-font-mono);\n  font-size: var(--curio-font-size-xs);\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n/* The chips' own colors, as the header's tags draw them (WidgetTags.module.css). */\n.chipInput {\n  border-color: #a8d5b1;\n  background: var(--curio-accent-mint-bg);\n  color: var(--curio-accent-mint-fg);\n}\n\n.chipColumn {\n  border-color: #a8d5b1;\n  background: var(--curio-card-bg);\n  color: var(--curio-accent-mint-fg);\n}\n\n.chipWidget {\n  border-color: #b6cbf2;\n  background: var(--curio-accent-sky-bg);\n  color: var(--curio-accent-sky-fg);\n}\n\n.chipSelection {\n  border-color: #f2b9a3;\n  background: var(--curio-accent-peach-bg);\n  color: #b8461d;\n}\n\n.chipScenario {\n  border-color: #cdbff0;\n  background: var(--curio-accent-lilac-bg);\n  color: var(--curio-accent-lilac-fg);\n}\n\n.chipProblem {\n  border-color: var(--curio-danger-border);\n  background: var(--curio-danger-bg);\n  color: var(--curio-danger-text);\n}\n\n.segment {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  white-space: nowrap;\n}\n\n.line {\n  overflow-wrap: anywhere;\n}\n\n.muted {\n  color: var(--curio-text-secondary);\n}\n\n.mono {\n  font-family: var(--curio-font-mono);\n  font-size: var(--curio-font-size-xs);\n}\n\n.problem {\n  color: var(--curio-danger-text);\n}\n\n.swatch {\n  display: inline-block;\n  flex: none;\n  width: 10px;\n  height: 10px;\n  margin-right: 4px;\n  border-radius: 2px;\n  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.25);\n  vertical-align: -1px;\n}\n\n.part {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.table {\n  border-collapse: collapse;\n}\n\n.caption {\n  caption-side: top;\n  padding-bottom: 3px;\n  text-align: left;\n  font-size: var(--curio-font-size-xs);\n  font-weight: 600;\n  color: var(--curio-text-primary);\n}\n\n.table th,\n.table td {\n  padding: 2px 14px 2px 0;\n  white-space: nowrap;\n}\n\n.table th:last-child,\n.table td:last-child {\n  padding-right: 0;\n}\n\n.table th {\n  border-bottom: 1px solid var(--curio-border);\n  text-align: left;\n  vertical-align: bottom;\n}\n\n.table td {\n  font-family: var(--curio-font-mono);\n  font-size: var(--curio-font-size-xs);\n  line-height: 15px;\n}\n\n.table .number {\n  text-align: right;\n}\n\n/* A cell, its column's name and its dtype each end in an ellipsis at the\n   width its column may take (inline, `cellWidth`), so every column shown\n   fits the card. */\n.cell {\n  display: inline-block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  vertical-align: bottom;\n}\n\n.columnName {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: var(--curio-font-size-xs);\n  font-weight: 600;\n  line-height: 15px;\n  color: var(--curio-text-primary);\n}\n\n.columnDtype {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-family: var(--curio-font-mono);\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 13px;\n  color: var(--curio-text-secondary);\n}\n\n.null {\n  color: var(--curio-text-secondary);\n}\n\n.foot {\n  flex: none;\n  font-size: var(--curio-font-size-xs);\n  line-height: 15px;\n  color: var(--curio-text-secondary);\n}\n\n/* An editor chip's tooltip: the markers' messages there, then its preview. */\n.tip {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.message {\n  font-family: var(--curio-font-family);\n  font-size: var(--curio-font-size-sm);\n  line-height: 16px;\n  color: var(--curio-text-primary);\n  white-space: pre-wrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"preview": `KjMiwpmsI8MADDc29O7m`,
	"head": `dH43014DOyU4YMwvW07f`,
	"body": `ItCGGRNbHgej8j0jeXDv`,
	"chip": `Mj0LZWmc8mDSa7WiCrFo`,
	"chipInput": `rVxn29MaO_K2CTe7D3DA`,
	"chipColumn": `YSnoColimRZpc1DAK2QT`,
	"chipWidget": `fy8hnHAYgtzCEKXcIt8i`,
	"chipSelection": `wbBLCQwjB4WSKgQEWAaM`,
	"chipScenario": `jEP7PeWqSMxBu5ZHQwIg`,
	"chipProblem": `bMVTkLrkcZhU0La_Ibzu`,
	"segment": `nq4lUyy2g30urSRRQJPD`,
	"line": `ltLawTr2bPvioObGkLNS`,
	"muted": `iGaUOLg0PNQ9PpiFazyi`,
	"mono": `Z8cvXDOUPNoHYlE5AzO5`,
	"problem": `dz9jMPDBxs59gQRvsDgp`,
	"swatch": `zIzqSfKieMdMVs0GJkdz`,
	"part": `hHV1x08vDjZQKcJiUgxb`,
	"table": `MJXlIUc9v8FJUhJUk06M`,
	"caption": `SeEGVv_cYNO6hg7GsSQK`,
	"number": `EHRT7X09uzRu1lX4b5HZ`,
	"cell": `TuGsG30TDwr9ZqdgrKPQ`,
	"columnName": `HlJCMj31ujvAlv3T9JBh`,
	"columnDtype": `SWbZGXluk4o9DzUrS73h`,
	"null": `BOO3oKJ4BV2KdAMyod1p`,
	"foot": `RFaqN1_aCLdr1NInAcvB`,
	"tip": `HRuoHDBzIiEtJvJKdXTj`,
	"message": `W2GpNZSTePUTPoMM6892`
};
export default ___CSS_LOADER_EXPORT___;
